export default {
  form: {
    font_family: {
      label: 'Rodzina czcionek',
    },
    header: {
      label: 'Nagłówek',
      placeholder: 'Nagłówek',
    },
    sub_header: {
      label: 'Podnagłówek',
      placeholder: 'Podnagłówek',
    },
    qr_code_header: {
      label: 'Nagłówek pola UI',
      placeholder: 'Nagłówek pola UI',
    },
    qr_code_description: {
      label: 'Opis pola UI',
      placeholder: 'Opis pola UI',
    },
    footer: {
      label: 'Tekst stopki',
      placeholder: 'Wpisz tekst stopki',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Wybierz URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Kolor główny',
    },
    background_color: {
      label: 'Kolor tła',
    },
    cover_image: {
      label: 'Obraz okładki',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Powiększenie logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować naklejki drzwiowej',
  },
};
